import { push } from 'react-router-redux';

export function appendAndGotoUrlCreator(name) {
  return (dispatch, getState) => {
    const { pathname: pathName } = getState().routing.locationBeforeTransitions;

    let pathToAdd = encodeURIComponent(name);

    // add slash if pathname does not include it
    if (pathName.slice(-1) !== '/') {
      pathToAdd = `/${pathToAdd}`;
    }

    const newPathName = `${pathName}${pathToAdd}`;

    dispatch(push(newPathName));
  };
}
